import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppLayout from "../../components/AppLayout";
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  Avatar,
} from "@mui/material";

export default function ViewStaffDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const staff = state || {
    id: "0",
    name: "Diya Kothari",
    image: "https://via.placeholder.com/400x500?text=Diya+Kothari",
    address: "Nagpur",
    phone: "9876543210",
    email: "diyakothari@gmail.com",
    salary: "₹ 15,000",
    designation: "Salesgirl",
  };

  return (
    <AppLayout>
      <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1200, mx: "auto" }}>
        <Button
          variant="contained"
          onClick={() => navigate(-1)}
          sx={{ bgcolor: "#C4A574", color: "#fff", mb: 3 }}
        >
          Previous
        </Button>

        <Typography
          variant="h3"
          align="center"
          sx={{
            mb: 4,
            fontWeight: 700,
            color: "#8B7355",
            textDecoration: "underline",
            textDecorationThickness: 2,
            textUnderlineOffset: 8,
          }}
        >
          STAFF DETAILS
        </Typography>

        <Paper
          elevation={0}
          sx={{
            bgcolor: "rgba(0,0,0,0.25)",
            p: { xs: 2, md: 4 },
            borderRadius: 1,
          }}
        >
          <Box
            sx={{
              maxWidth: 1000,
              mx: "auto",
              bgcolor: "white",
              border: "2px solid #C4A574",
              borderRadius: 1,
              overflow: "hidden",
            }}
          >
            <Grid container>
              <Grid item xs={12} md={4} sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
                <Avatar
                  src={staff.image}
                  alt={staff.name}
                  variant="rounded"
                  sx={{ width: { xs: 200, md: 320 }, height: { xs: 200, md: 320 } }}
                />
              </Grid>

              <Grid item xs={12} md={8} sx={{ p: { xs: 2, md: 6 } }}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography sx={{ color: "#C4A574", fontWeight: 700 }}>STAFF NAME:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ color: "#8B7355", fontWeight: 600 }}>{staff.name}</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography sx={{ color: "#C4A574", fontWeight: 700 }}>ADDRESS:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ color: "#8B7355", fontWeight: 600 }}>{staff.address}</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography sx={{ color: "#C4A574", fontWeight: 700 }}>PHONE NUMBER:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ color: "#8B7355", fontWeight: 600 }}>{staff.phone}</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography sx={{ color: "#C4A574", fontWeight: 700 }}>EMAIL ID:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ color: "#8B7355", fontWeight: 600 }}>{staff.email}</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography sx={{ color: "#C4A574", fontWeight: 700 }}>MONTHLY SALARY:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ color: "#8B7355", fontWeight: 600 }}>₹ {staff.salary}</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography sx={{ color: "#C4A574", fontWeight: 700 }}>DESIGNATION:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ color: "#8B7355", fontWeight: 600 }}>{staff.designation}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Box>
    </AppLayout>
  );
}
